
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { EnrichedVisitor } from "@/types/database";
import VisitorCardContent from "./VisitorCardContent";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { exportVisitorsToCSV } from "@/utils/exportUtils";

interface VisitorDialogProps {
  visitor: EnrichedVisitor | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

const VisitorDialog = ({ visitor, isOpen, onOpenChange }: VisitorDialogProps) => {
  if (!visitor) return null;

  const handleDownload = () => {
    if (visitor) {
      // Create a set with only this visitor's ID for the export function
      const selectedIds = new Set<string>([visitor.id]);
      exportVisitorsToCSV([visitor], selectedIds);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[600px] max-h-[85vh]">
        <DialogHeader className="flex flex-row items-center justify-between">
          <div>
            <DialogTitle className="text-lg">Lead details</DialogTitle>
            <DialogDescription>
              View complete information about this lead
            </DialogDescription>
          </div>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={handleDownload}
            className="gap-2"
          >
            <Download className="h-4 w-4" /> Export CSV
          </Button>
        </DialogHeader>

        <ScrollArea className="max-h-[calc(85vh-120px)] overflow-y-auto pr-4">
          <div className="w-full">
            <VisitorCardContent visitor={visitor} isOpen={isOpen} />
          </div>
          <ScrollBar orientation="vertical" />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}

export default VisitorDialog;
